import React from 'react';
import './PlantBackground.css';

const PlantBackground = () => {
  return (
    <div className="plant-bg" aria-hidden="true">
      {/* 
        Using the hyperrealistic 8K plant images we already have!
        By scaling them up, rotating them to hide the pots off-screen, 
        and using mix-blend-mode: lighten, they seamlessly become 
        the perfect climbing vines and corner plants from your theme!
      */}
      <img src="/images/monstera.png" alt="corner plant" className="bg-img-leaf bg-top-right" />
      <img src="/images/palm.png" alt="corner plant" className="bg-img-leaf bg-bottom-left" />
      <img src="/images/fiddle.png" alt="corner plant" className="bg-img-leaf bg-mid-left" />
      <img src="/images/monstera.png" alt="corner plant" className="bg-img-leaf bg-mid-right" />

      {/* Floating particles for magical atmosphere */}
      <div className="plant-particles">
        {[...Array(12)].map((_, i) => (
          <div key={i} className={`particle particle-${i + 1}`} />
        ))}
      </div>

      {/* Deep moody glows */}
      <div className="glow-spot glow-1" />
      <div className="glow-spot glow-2" />
      <div className="glow-spot glow-3" />
    </div>
  );
};

export default PlantBackground;
